@use "@fukuri-admins/ui/layout" as *;

.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: spacing('24');
  height: 100%;
}

.box {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: background('Secondary');
  border-radius: borderRadius('full');
  padding: spacing('32') spacing('24');
}

.image {
  width: auto;
  height: auto;
  margin-left: -24px;
  &:not(:first-child) {
    margin-left: -32px;
  }
}

.description {
  @include typography('Jp/14_W3');
  color: text('Middle');
  text-align: center;
}

.emptyText {
  @include typography('Jp/16_W3');
  color: text('Low');
}